const INITIAL_STATE = {
    configurations: [],
};

export default function (state = INITIAL_STATE, action: any) {
    switch (action.type) {
        case 'SET_CONFIGURATIONS':
            return {
                ...state,
                configurations: { ...action.payload },
            };
        default:
            return { ...state };
    }
}
